import {makeReducer} from '../../redux-toolbelt';

import {settingDataInStoreAccordingToApiResponse} from './settingDataInStoreAccordingToApiResponseActions';

type SettingDataInStoreAccordingToApiResponseState = boolean;

export default makeReducer<SettingDataInStoreAccordingToApiResponseState, boolean>(settingDataInStoreAccordingToApiResponse, {
  defaultState: false,
});
